'use strict';

import { filter, forOwn, get, isNil, isUndefined, merge, omit } from 'lodash';
import { Component, PropTypes } from 'react';
import ValidatedForm from './../ValidatedForm';
import PureRenderMixin from 'react-addons-pure-render-mixin';

// 1900 for calendar min date
const year1900 = new Date(-5700000000000);

// values for a boolean dropdown or toggle button
const booleanDropDown = [
  {
    value: true,
    primaryText: 'Yes'},
  {
    value: false,
    primaryText: 'No'
  }
];


export default class ProgressComponent extends ValidatedForm {
  static propTypes = {
    // updateing state
    tempState: PropTypes.object.isRequired,
    updateTempState: PropTypes.func.isRequired,

    // handles viewState
    viewState: PropTypes.object.isRequired,
    viewModel: PropTypes.string.isRequired, // string path to view property

    // tracking errors
    errorCount: PropTypes.number.isRequired,

    // string determining model type
    model: PropTypes.string.isRequired,
  }


  componentWillMount() {
    //this.updateProgress();
  }

  componentWillReceiveProps(nextProps) {
    //this.updateProgress(nextProps);
  }

  // performance optimization
  shouldComponentUpdate = ::PureRenderMixin.shouldComponentUpdate;

  year1900 = year1900;

  today = new Date();

  booleanDropDown = booleanDropDown;

  updateProgress = (nextProps) => {
    const props = nextProps || this.props;
    const objPath = `viewState.progress.applicant.application.${this.props.viewModel}.done`;

    // validation vs state and tempState
    let isValid = !props.errorCount;
    const viewStateDone = get(props.viewState, 'done', false);
    const tempStateDone = get(props.tempState, `profile.${objPath}`);

    if(viewStateDone !== isValid) {
      if(tempStateDone !== isValid) {
        // if property is not on tempstate and is different from state add it to tempstate
        props.updateTempState('profile', objPath, null, isValid);
      }
    } else if (!isNil(tempStateDone)) {
      // if property is set on tempstate and is actually the same as tempstate remove it
      props.updateTempState('profile', objPath, null, undefined);
    }
  }

  updateTempState = (parent, prop, event, val, cb) => {
    const value = !isUndefined(val) ? val : get(event, 'target.value');

    if(get(this.props[this.props.model], prop) === value) {
      this.props.updateTempState(parent, prop, event, undefined, cb);
    } else {
      this.props.updateTempState(parent, prop, event, value, cb);
    }
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/C_ProgressComponent/index.js